/* Gourmandises & Cie — en-tête animé (portage du prototype sources/prototypes/entete-anime, v13).
   Pose data-gcie-state, data-gcie-drip et --gcie-p sur #header-component d'après le défilement,
   injecte le lettrage horizontal, le calque de dégradé et la coulure, centre le creux du menu et y pose le logo.
   Vanilla, chargé en `defer` par layout/theme.liquid ; les tailles vivent dans gcie-custom.css. */
(() => {
  'use strict';
  const header = document.getElementById('header-component');
  if (!header || header.dataset.gcieReady) return;
  header.dataset.gcieReady = 'true';

  const script = document.currentScript || document.querySelector('script[data-gcie-wordmark]');
  const WORDMARK = script ? script.dataset.gcieWordmark : '';
  const REDUCE = matchMedia('(prefers-reduced-motion: reduce)');
  const DESKTOP = matchMedia('(min-width: 750px)');
  const SQUEEZE = matchMedia('(min-width: 990px)'); // Horizon fait défiler .page-wrapper à partir de 990 px
  const SVG_NS = 'http://www.w3.org/2000/svg';

  // ── Coulure : tracé exact du logo (coulure.json), coordonnées absolues 200→480 × 0→49 ──
  const COULURE = 'M 200.0 0.0 C 209.0 0.0 218.0 2.6 225.71 3.03 C 234.59 7.13 244.24 6.58 255.04 6.99 C 267.95 7.47 277.8 11.86 287.0 20.99 C 295.37 29.3 299.32 42.84 309.71 48.86 C 321.91 55.96 337.68 50.99 344.93 39.46 C 351.62 28.81 353.56 12.48 366.52 6.72 C 379.25 1.04 387.06 15.79 397.21 20.76 C 408.68 26.38 415.26 18.95 425.89 15.29 C 435.43 11.99 450.07 13.04 458.17 6.19 C 465.0 6.3 471.0 3.2 480.0 0.0 L 200.0 0.0 Z';
  const CX = 310, DEPTH = 48.9; // creux principal (x) et profondeur finale
  const tok = COULURE.match(/[MLCZ]|-?\d+\.?\d*/g); const cmds = [];
  for (let i = 0; i < tok.length;) {
    const t = tok[i];
    if (t === 'M' || t === 'L') { cmds.push([t, [+tok[i + 1], +tok[i + 2]]]); i += 3; }
    else if (t === 'C') { cmds.push(['C', tok.slice(i + 1, i + 7).map(Number)]); i += 7; }
    else { cmds.push(['Z', []]); i += 1; }
  }
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const smooth = (t) => t * t * (3 - 2 * t);
  const easeOut = (t) => 1 - Math.pow(1 - t, 3);

  // Forme à la progression p — copie à l'identique du prototype : bosse → col → pose.
  function forme(p) {
    let f, pinch = 0;
    if (p < 0.4) { f = 0.32 * smooth(p / 0.4); }
    else if (p < 0.85) { const q = (p - 0.4) / 0.45; f = 0.32 + 0.74 * easeOut(q); pinch = Math.sin(Math.PI * q) * 0.42; }
    else { const q = (p - 0.85) / 0.15; f = 1.06 - 0.06 * smooth(q); pinch = 0.42 * (1 - smooth(q)) * 0.25; }
    const pt = (x, y) => {
      const yy = y * f;
      const dx = x - CX, near = Math.exp(-(dx * dx) / (2 * 28 * 28));
      const depthN = clamp(y / DEPTH, 0, 1), col = Math.exp(-Math.pow((depthN - 0.45) / 0.22, 2));
      const k = 1 - pinch * near * col;
      return [(CX + dx * k).toFixed(2), yy.toFixed(2)];
    };
    return cmds.map(([t, c]) => t === 'Z' ? 'Z' : t + ' ' + (t === 'C'
      ? [pt(c[0], c[1]), pt(c[2], c[3]), pt(c[4], c[5])].flat().join(' ')
      : pt(c[0], c[1]).join(' '))).join(' ');
  }

  // ── Injections : lettrage dans le lien du logo, calque de dégradé, coulure ──
  const logo = header.querySelector('.header-logo');
  if (logo && WORDMARK && !logo.querySelector('.gcie-wordmark')) {
    const img = document.createElement('img');
    img.className = 'gcie-wordmark';
    img.alt = ''; // le lien porte déjà son libellé (alt du logo)
    img.width = 1162; img.height = 154;
    img.decoding = 'async';
    img.src = WORDMARK;
    logo.appendChild(img);
  }
  const glow = document.createElement('div');
  glow.className = 'gcie-glow';
  glow.setAttribute('aria-hidden', 'true');
  const underlay = header.querySelector('.header__underlay-open');
  if (underlay) underlay.insertAdjacentElement('afterend', glow); else header.prepend(glow);

  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('class', 'gcie-drip');
  svg.setAttribute('viewBox', '200 0 280 54');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('focusable', 'false');
  const path = document.createElementNS(SVG_NS, 'path');
  path.setAttribute('d', 'M 0 0');
  svg.appendChild(path);
  header.appendChild(svg);

  // ── Menu scindé : creux après la moitié gauche des entrées visibles, recentré sur la barre.
  //    Le logo est posé au centre du creux RÉEL (--gcie-logo-dx), jamais au centre de la page
  //    en aveugle : quand la colonne du menu (bornée par les icônes) ne permet pas de centrer le
  //    creux, on resserre d'abord les écarts (--gcie-serrage, px retirés à chaque écart, bornés
  //    par les minima du CSS) puis on désaxe, logo compris. Aucun chevauchement possible : le
  //    creux fait toujours au moins la largeur du logo + 2 respirations minimales.
  //    Le menu peut être ré-hydraté par Horizon : on le retrouve à chaque passage. ──
  let splitItem = null, shift = 0, serrage = 0, logoDx = 0, menuCourant = null, ajustements = 0;
  function poserCreux(item) {
    if (splitItem && splitItem !== item) splitItem.classList.remove('gcie-split-after');
    if (item) item.classList.add('gcie-split-after');
    splitItem = item;
  }
  function appliquer(menu, valeur) {
    shift = valeur;
    menu.style.transform = valeur ? `translateX(${valeur}px)` : '';
  }
  function poserLogo(dx) {
    logoDx = dx;
    header.style.setProperty('--gcie-logo-dx', `${dx}px`);
  }
  // Méga-menu sur toute la largeur de la fenêtre (consigne du 21/09) : le panneau a pour
  // conteneur .header-menu, que le recentrage décale (transform) ; il en héritait la largeur
  // (1 100 px à 1 440). On publie la position AFFICHÉE de .header-menu dans la fenêtre (le
  // panneau suit le même transform) et la largeur utile ; le CSS étend le panneau d'autant, et la
  // grille native d'Horizon aligne alors ses colonnes sur le contenu des sections. Relu à chaque
  // entrée dans l'en-tête (survol, focus clavier), pas seulement au recentrage : la position
  // lue au moment de l'ouverture est toujours la bonne.
  let panneauX = null, panneauL = null;
  function poserPanneau() {
    const menu = header.querySelector('.header__column--center .header-menu');
    if (!menu) return;
    // Repère : l'en-tête lui-même (au bureau, Horizon fait défiler .page-wrapper, dont la barre
    // de défilement n'appartient pas à la fenêtre : documentElement serait 11 px trop large).
    const h = header.getBoundingClientRect();
    const x = Math.round(menu.getBoundingClientRect().left - h.left);
    const l = Math.round(h.width);
    if (x !== panneauX) { panneauX = x; header.style.setProperty('--gcie-panneau-x', `${x}px`); }
    if (l !== panneauL) { panneauL = l; header.style.setProperty('--gcie-panneau-l', `${l}px`); }
  }
  header.addEventListener('pointerover', poserPanneau, { passive: true });
  header.addEventListener('focusin', poserPanneau);
  function poserSerrage(s) {
    serrage = s;
    header.style.setProperty('--gcie-serrage', `${s}px`);
  }
  // Décalage horizontal réellement rendu (le transform peut être en cours de transition) :
  // toutes les mesures sont ramenées au repère sans décalage pour converger en une passe.
  function decalageRendu(el) {
    const t = getComputedStyle(el).transform;
    const m = t && t !== 'none' ? t.match(/matrix(3d)?\(([^)]+)\)/) : null;
    if (!m) return 0;
    const v = m[2].split(',').map(parseFloat);
    return (m[1] ? v[12] : v[4]) || 0;
  }
  function entreesVisibles(list) {
    // Entrées visibles seulement : ni l'entrée « Plus » (slot="more"), ni celles rangées dans
    // l'overflow (slot="overflow"), ni les masquées (rectangle nul).
    return Array.from(list.children).filter((el) => {
      if (el.tagName !== 'LI' || el.hidden || el.slot === 'overflow' || el.slot === 'more') return false;
      return el.getBoundingClientRect().width > 0;
    });
  }
  function mesurer() {
    const menu = header.querySelector('.header__column--center .header-menu');
    const list = menu ? menu.querySelector('overflow-list') : null;
    if (!menu || !list) return { menu, list };
    const items = entreesVisibles(list);
    const k = Math.ceil(items.length / 2);
    const gauche = items[k - 1], droite = items[k];
    if (!gauche || !droite) return { menu, list, items };
    const tx = decalageRendu(menu);
    const a = gauche.getBoundingClientRect(), b = droite.getBoundingClientRect();
    const cols = menu.closest('.header__columns') || header; // contenant du logo (left: 50 %)
    const c = cols.getBoundingClientRect();
    const colonne = (menu.parentElement || cols).getBoundingClientRect();
    const m = list.getBoundingClientRect(); // largeur réelle du menu, bouton « Plus » compris
    return {
      menu, list, items, gauche, droite, tx,
      centre: (c.left + c.right) / 2,
      creux: (a.right + b.left) / 2 - tx, // centre du creux, repère sans décalage
      colonneG: colonne.left, colonneD: colonne.right,
      menuG: m.left - tx, menuD: m.right - tx,
      plus: !!list.querySelector('li[slot="overflow"]'),
    };
  }
  function scinder() {
    const x = mesurer();
    if (menuCourant && menuCourant !== x.menu) { shift = 0; serrage = 0; } // nœud remplacé : styles inline perdus
    menuCourant = x.menu;
    if (!x.menu || !x.list) { poserCreux(null); poserLogo(0); return; }
    if (!DESKTOP.matches || !x.gauche) { poserCreux(null); appliquer(x.menu, 0); poserLogo(0); poserSerrage(0); return; }
    poserCreux(x.gauche);
    // Décalage idéal, borné à la colonne du menu : la borne droite (icônes) prime toujours.
    const ideal = Math.round(x.centre - x.creux);
    const maxDroite = Math.floor(x.colonneD - x.menuD);
    const maxGauche = Math.ceil(x.colonneG - x.menuG);
    let nouveau = Math.min(ideal, maxDroite);
    if (maxGauche <= maxDroite) nouveau = Math.max(nouveau, maxGauche);
    if (nouveau !== shift || !x.menu.style.transform) appliquer(x.menu, nouveau);
    // Logo au centre du creux réel (0 quand le creux est centré).
    const dx = Math.round(x.creux + nouveau - x.centre);
    if (dx !== logoDx) poserLogo(dx);
    poserPanneau();
    // Serrage : chaque px retiré aux écarts (n−1 écarts, 2 respirations, 2n marges de lien)
    // rapproche le creux du centre d'environ (3n+1)/2 px tant que le menu bute à droite.
    const n = x.items.length, gain = (3 * n + 1) / 2, sMax = cssNum('--gcie-serrage-max') || 12;
    const reste = ideal - nouveau, marge = maxDroite - nouveau;
    let s = serrage;
    if (maxGauche > maxDroite) s = sMax;                                   // le menu déborde : tout resserrer
    else if (reste > 0 && s < sMax) s = Math.min(sMax, s + Math.max(1, Math.ceil(reste / gain)));
    else if (reste <= 0 && s > 0 && marge >= 2 * gain) s = Math.max(0, s - Math.floor(marge / gain) + 1);
    if (s !== serrage && ajustements < 12) { ajustements += 1; poserSerrage(s); } // garde-fou anti-boucle
  }
  // Rejoue le centrage après le premier rendu d'<overflow-list> et à chaque changement du menu.
  const rescinder = () => requestAnimationFrame(scinder);
  const observeur = new MutationObserver(rescinder);
  observeur.observe(header, { childList: true, subtree: true, attributes: true, attributeFilter: ['slot', 'hidden'] });
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(rescinder);
    ro.observe(header);
    const menu0 = header.querySelector('.header__column--center .header-menu');
    if (menu0) ro.observe(menu0);
  }
  window.addEventListener('load', rescinder);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(rescinder);

  // Auto-vérification (à appeler dans la console) : creux réel, logo visible, chevauchement.
  function controle() {
    const x = mesurer();
    const logoEl = header.querySelector('.header__column--center .header-logo');
    const etat = header.dataset.gcieState || 'inactive';
    const img = logoEl && logoEl.querySelector(etat === 'active' ? '.gcie-wordmark' : '.header-logo__image');
    const L = (img || logoEl) ? (img || logoEl).getBoundingClientRect() : null;
    const r1 = (v) => Math.round(v * 10) / 10;
    const logo = L ? { gauche: r1(L.left), droite: r1(L.right), largeur: r1(L.width), centre: r1((L.left + L.right) / 2) } : null;
    if (!x.gauche || !logo) return { largeur: innerWidth, etat, creux: null, logo, chevauchement: false, motif: 'menu scindé inactif' };
    const a = x.gauche.getBoundingClientRect(), b = x.droite.getBoundingClientRect();
    const creux = { gauche: r1(a.right), droite: r1(b.left), largeur: r1(b.left - a.right), centre: r1((a.right + b.left) / 2) };
    return {
      largeur: innerWidth, etat, creux, logo,
      chevauchement: L.left < a.right - 0.5 || L.right > b.left + 0.5,
      respiration: { gauche: r1(L.left - a.right), droite: r1(b.left - L.right) },
      ecartCentre: r1(creux.centre - x.centre), decalageMenu: shift, logoDx, serrage,
      plus: x.plus, entreesVisibles: x.items.length,
    };
  }

  // ── Pilotage par le défilement ──
  const scroller = () => (SQUEEZE.matches && document.querySelector('.page-wrapper')) || null;
  const scrollY = () => { const s = scroller(); return s ? s.scrollTop : (window.scrollY || document.documentElement.scrollTop || 0); };
  const cssNum = (name) => parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name)) || 0;
  let raf = 0, dernierP = -1, dernierEtat = '', dernierDrip = '';
  function maj() {
    raf = 0;
    const seuil = Math.max(0, cssNum('--gcie-h') - cssNum('--gcie-h-compact'));
    const run = cssNum('--gcie-drip-run') || 280;
    const y = scrollY();
    const etat = y >= seuil ? 'active' : 'inactive';
    if (etat !== dernierEtat) { header.dataset.gcieState = etat; dernierEtat = etat; }
    let p = clamp((y - seuil) / run, 0, 1);
    if (REDUCE.matches) p = p >= 0.5 ? 1 : 0; // pas de formation : fondu à la forme finale
    const drip = p > 0 ? 'on' : 'off';
    if (drip !== dernierDrip) { header.dataset.gcieDrip = drip; dernierDrip = drip; }
    if (p !== dernierP) { path.setAttribute('d', forme(p)); header.style.setProperty('--gcie-p', p.toFixed(3)); dernierP = p; }
  }
  const planifier = () => { if (!raf) raf = requestAnimationFrame(maj); };
  let scrollTarget = null;
  function ecouter() {
    const cible = scroller() || window;
    if (cible === scrollTarget) return;
    if (scrollTarget) scrollTarget.removeEventListener('scroll', planifier);
    cible.addEventListener('scroll', planifier, { passive: true });
    scrollTarget = cible;
  }
  ecouter();
  SQUEEZE.addEventListener('change', () => { ecouter(); planifier(); });
  DESKTOP.addEventListener('change', rescinder);
  REDUCE.addEventListener('change', planifier);
  window.addEventListener('resize', () => { ajustements = 0; planifier(); rescinder(); });
  maj();
  scinder();
  window.gcieHeaderMaj = maj; // pour les tests (rAF suspendu dans une fenêtre masquée)
  window.gcieHeaderScinder = scinder;
  window.gcieHeaderControle = controle;
})();
